import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const LeaveManagement = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        İzin Yönetimi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>İzin yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default LeaveManagement;
